import React from "react";
import { regexFirstCharacter } from "../helpers";
import { Wrapper } from "./indicatorBar.styles";
import PropTypes from "prop-types";

export const IndicatorBar = ({
  backgroundColor,
  isActive,
  showIndicatorStatus,
  daysUntilExpiry,
  declineIsActive,
}) => {
  let showExpiry = false;

  if (!!daysUntilExpiry) {
    let checkIfExpiryNegative = regexFirstCharacter(daysUntilExpiry, "-");
    let checkIfExpiryZero = regexFirstCharacter(daysUntilExpiry, "0");
    showExpiry = !checkIfExpiryNegative && !checkIfExpiryZero;
  }

  return (
    <Wrapper
      $showIndicatorStatus={showIndicatorStatus}
      $isActive={isActive}
      $backgroundColor={backgroundColor}
    >
      <div className="indicator-bar" />
      {showExpiry === true ? (
        <div className="indicator-status">Expiring in <span>{daysUntilExpiry}</span></div>
      ) : (
        ""
      )}
      {declineIsActive && <div className="indicator-status">DECLINED</div>}
      <div className="indicator-bar" />
    </Wrapper>
  );
};

IndicatorBar.propTypes = {
  backgroundColor: PropTypes.string,
  isActive: PropTypes.bool,
  showIndicatorStatus: PropTypes.bool,
  daysUntilExpiry: PropTypes.string,
  declineIsActive: PropTypes.bool,
}